<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <a-col :span="8" class="col-form">
        <center><img src="images/logo.png" width="300" /></center>
        <a-form id="components-form-demo-normal-login" class="login-form" :hideRequiredMark="true">
          <a-form-item class="mb-10" label="Username" :colon="false">
            <a-input placeholder="รหัสผู้ใช้ PGVIM Wifi" v-model="username" />
          </a-form-item>
          <a-form-item class="mb-5" label="Password" :colon="false">
            <a-input type="password" placeholder="รหัสผ่าน" v-model="password" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" block html-type="submit" class="login-form-button" :loading="this.loading"
              @click="handleSubmit">
              เข้าสู่ระบบ
            </a-button>
            <a-divider />
            <a-button type="default" block class="login-form-button" @click="handleRegister">
              ลงทะเบียนบัตรใหม่
            </a-button>
          </a-form-item>
          <center>
            <a href="/manual.pdf" target="_blank">คู่มือการใช้งาน</a><br />
            <span style="color: #ff0000">{{ messageTH }}<br />{{ messageEN }}</span>
          </center>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      messageTH: "",
      messageEN: ""
    };
  },
  components: {},
  beforeCreate() { },
  methods: {
    //
    //
    //
    handleRegister() {
      this.$router.push("/login-register");
    },
    //
    //
    //
    handleSubmit() {
      this.messageTH = "";
      this.messageEN = "";

      if (this.username === "" || this.password === "") {
        this.messageTH = "กรุณาใส่ Username และ Password";
        return;
      }

      this.loading = true;

      let username = this.username.toLowerCase();
      axios
        .post(process.env.VUE_APP_AUTHEN_API + "/login", {
          email: this.username,
          password: this.password
        })
        .then(response => {
          // Store info to localstorage.
          localStorage.setItem("accessToken", response.data.token);
          localStorage.setItem("id", response.data.id);
          localStorage.setItem("username", response.data.username);
          localStorage.setItem("name", response.data.name);
          localStorage.setItem("type", response.data.type);
          localStorage.setItem("role", response.data.role);
          localStorage.setItem("phone", response.data.phone);
          localStorage.setItem("ban", response.data.ban);
          localStorage.setItem("status", response.data.status);

          // Redirect to dashboard page.
          let role = localStorage.getItem("role");
          if (role === "Admin") {
            let type = localStorage.getItem("type");
            if (type === "AdminSystem") {
              this.$router.push("/dashboard-admin-system");
            } else if (type === "Admin") {
              this.$router.push("/dashboard-admin");
            } else if (type === "Officer") {
              this.$router.push("/dashboard-officer");
            } else if (type === "Officer") {
              this.$router.push("/dashboard-teacher");
            }
          } else {
            this.$router.push("/dashboard-user");
          }
        })
        .catch(error => {
          this.messageTH =
            "เข้าใช้งานไม่สำเร็จ โปรดติดต่อเจ้าหน้าที่เพื่อสอบถามช้อมูลเพิ่มเติม";
          this.messageEN =
            "Log in unsuccessful. Please contact our staff for more information.";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
</style>
